import { PrivacyPolicyItems, PrivacyPolicyItemsContent, PrivacyPolicyItemsTitle, PrivacyPolicySubtitle, PrivacyPolicyTitle, Wrapper, } from "./style";

export const PrivacyPolicy = () => {
	return (
		<Wrapper>
			<PrivacyPolicyTitle>
				Политика конфиденциальности
				<PrivacyPolicySubtitle>
					в отношении обработки персональных данных 
				</PrivacyPolicySubtitle>
			</PrivacyPolicyTitle>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					1. ОБЩИЕ ПОЛОЖЕНИЯ
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
						1.1. Настоящая политика в отношении обработки персональных данных (далее Политика) устанавливает основные положения в отношении обработки персональных данных пользователей сайта (далее Субъект персональных данных), собираемых ООО «AMMY TRAVEL» (далее Администрация) на принадлежащем ему сайте <a href="/" target="_blank">https://avia.alif.uz</a> (далее – сайт).
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.2. Администрация руководствуется следующими основными принципами обработки персональных данных:
					<ul>
						<li>
							обработка персональных данных должна осуществляться на законной и справедливой основе;
						</li>
						<li>
							обработка персональных данных должна ограничиваться достижением конкретных, заранее определенных и законных целей;
						</li>
						<li>
							не допускается обработка персональных данных, несовместимая с целями сбора персональных данных;
						</li>
						<li>
							не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой;
						</li>
						<li>
							обработке подлежат только персональные данные, которые отвечают целям их обработки;
						</li>
						<li>
							содержание и объем обрабатываемых персональных данных должны соответствовать заявленным целям обработки;
						</li>
						<li>
							обрабатываемые персональные данные не должны быть избыточными по отношению к заявленным целям их обработки;
						</li>
						<li>
							при обработке персональных данных должны быть обеспечены точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных;
						</li>
						<li>
							Администрация должна принимать необходимые меры либо обеспечивать их принятие по удалению или уточнению неполных или неточных данных;
						</li>
						<li>
							хранение персональных данных должно осуществляться в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен законом, договором, одной из сторон;
						</li>
						<li>
							обрабатываемые персональные данные подлежат уничтожению либо обезличиванию по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено законом.
						</li>
					</ul>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.3. Обработка персональных данных осуществляется исключительно в целях оказания услуг, за которыми обращается субъект персональных данных на сайт Администрации. 
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.4. Субъект персональных данных принимает решение о предоставлении его персональных данных и дает согласие на их обработку свободно, своей волей и в своем интересе. Согласие на обработку персональных данных должно быть конкретным, информированным и сознательным. Согласие на обработку персональных данных может быть дано субъектом персональных данных или его представителем в любой позволяющей подтвердить факт его получения форме, если иное не установлено Законом. 
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					2. ПРАВА СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					2.1. Субъект персональных данных имеет право на получение следующих сведений (далее – сведения):
					<ul>
						<li>
							подтверждение факта обработки персональных данных Администрацией; 
						</li>
						<li>
							правовые основания и цели обработки персональных данных; 
						</li>
						<li>
							цели и применяемые Администрацией способы обработки персональных данных; 
						</li>
						<li>
							наименование и место нахождения Администрации, сведения о лицах (за исключением работников Администрации), которые имеют доступ к персональным данным или которым могут быть раскрыты персональные данные на основании договора с Администрацией или на основании законодательства в рамках юрисдикции Администрации;
						</li>
						<li>
							обрабатываемые персональные данные, относящиеся к соответствующему субъекту персональных данных, источник их получения, если иной порядок представления таких данных не предусмотрен Законом; 
						</li>
						<li>
							сроки обработки персональных данных, в том числе сроки их хранения; 
						</li>
						<li>
							порядок осуществления субъектом персональных данных его прав;
						</li>
						<li>
							информацию об осуществленной или о предполагаемой трансграничной передаче данных;
						</li>
						<li>
							иные сведения, предусмотренные действующим законодательством в рамках юрисдикции Администрации.
						</li>
					</ul>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					2.2. Субъект персональных данных вправе требовать от Администрации уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					2.3. Сведения должны быть предоставлены субъекту персональных данных Администрацией в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, если имеются законные основания для раскрытия таких персональных данных.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.4. Сведения предоставляются субъекту персональных данных или его представителю Администрацией при обращении либо при получении запроса субъекта персональных данных или его представителя. Запрос должен содержать номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе, сведения, подтверждающие участие субъекта персональных данных в отношениях с Администрацией (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных Администрацией, подпись субъекта персональных данных или его представителя.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.5. В случае, если сведения, а также обрабатываемые персональные данные были предоставлены для ознакомления субъекту персональных данных по его запросу, субъект персональных данных вправе обратиться повторно к Администрации или направить ему повторный запрос в целях получения сведений и ознакомления с такими персональными данными не ранее чем через тридцать дней после первоначального обращения или направления первоначального запроса.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.6. Обработка персональных данных в целях продвижения товаров, работ, услуг на рынке путем осуществления прямых контактов с потенциальным потребителем с помощью средств связи, а также в целях политической агитации допускается только при условии предварительного согласия субъекта персональных данных. Указанная обработка персональных данных признается осуществляемой без предварительного согласия субъекта персональных данных, если Администрация не докажет, что такое согласие было получено.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.7. Запрещается принятие на основании исключительно автоматизированной обработки персональных данных решений, порождающих юридические последствия в отношении субъекта персональных данных или иным образом затрагивающих его права и законные интересы.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.8. Решение, порождающее юридические последствия в отношении субъекта персональных данных или иным образом затрагивающее его права и законные интересы, может быть принято на основании исключительно автоматизированной обработки его персональных данных только при наличии согласия в письменной форме субъекта персональных данных или в случаях, предусмотренных федеральными законами, устанавливающими также меры по обеспечению соблюдения прав и законных интересов субъекта персональных данных.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					2.9. Администрация обязана разъяснить субъекту персональных данных порядок принятия решения на основании исключительно автоматизированной обработки его персональных данных и возможные юридические последствия такого решения, предоставить возможность заявить возражение против такого решения, а также разъяснить порядок защиты субъектом персональных данных своих прав и законных интересов.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					2.10. Если субъект персональных данных считает, что Администрация осуществляет обработку его персональных данных с нарушением требований закона или иным образом нарушает его права и свободы, субъект персональных данных вправе обжаловать действия или бездействие Администрации в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.11. Субъект персональных данных имеет право на защиту своих прав и законных интересов, в том числе на возмещение убытков и (или) компенсацию морального вреда в судебном порядке.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					3. ОБЯЗАННОСТИ АДМИНИСТРАЦИИ
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					3.1. При сборе персональных данных Администрация обязана предоставить субъекту персональных данных по его просьбе сведения, указанные в пункте 2.1 настоящей Политики.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.2. Если предоставление персональных данных является обязательным в соответствии с законом, Администрация обязана разъяснить субъекту персональных данных юридические последствия отказа предоставить его персональные данные.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.3. Если персональные данные получены не от субъекта персональных данных, Администрация до начала обработки таких персональных данных обязана предоставить субъекту персональных данных следующую информацию:
					<ul>
						<li>
							наименование либо фамилия, имя, отчество и адрес Администрации или его представителя;
						</li>
						<li>
							цель обработки персональных данных и ее правовое основание;
						</li>
						<li>
							предполагаемые пользователи персональных данных;
						</li>
						<li>
							права субъекта персональных данных;
						</li>
						<li>
							источник получения персональных данных.
						</li>
					</ul>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					Администрация освобождается от обязанности предоставить субъекту персональных указанную информацию в случаях, если:
					<ul>
						<li>
							субъект персональных данных уведомлен об осуществлении обработки его персональных данных соответствующей Администрацией;
						</li>
						<li>
							персональные данные получены Администрацией на основании закона или в связи с исполнением договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных;
						</li>
						<li>
							персональные данные сделаны общедоступными субъектом персональных данных или получены из общедоступного источника;
						</li>
						<li>
							Администрация осуществляет обработку персональных данных для статистических или иных исследовательских целей, для осуществления профессиональной деятельности журналиста либо научной, литературной или иной творческой деятельности, если при этом не нарушаются права и законные интересы субъекта персональных данных;
						</li>
						<li>
							предоставление субъекту персональных данных указанной информации нарушает права и законные интересы третьих лиц.
						</li>
					</ul>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.4. При сборе персональных данных, в том числе посредством информационно-телекоммуникационной сети «Интернет», Администрация обязана обеспечить запись, систематизацию, накопление, хранение, уточнение (обновление, изменение).
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.5. В случае выявления неправомерной обработки персональных данных при обращении субъекта персональных данных или его представителя либо по запросу субъекта персональных данных или его представителя либо уполномоченного органа по защите прав субъектов персональных данных Администрация обязана осуществить блокирование неправомерно обрабатываемых персональных данных, относящихся к этому субъекту персональных данных, или обеспечить их блокирование (если обработка персональных данных осуществляется другим лицом, действующим по поручению Администрации) с момента такого обращения или получения указанного запроса на период проверки. В случае выявления неточных персональных данных при обращении субъекта персональных данных или его представителя либо по их запросу или по запросу уполномоченного органа по защите прав субъектов персональных данных Администрация обязана осуществить блокирование персональных данных, относящихся к этому субъекту персональных данных, или обеспечить их блокирование (если обработка персональных данных осуществляется другим лицом, действующим по поручению Администрации) с момента такого обращения или получения указанного запроса на период проверки, если блокирование персональных данных не нарушает права и законные интересы субъекта персональных данных или третьих лиц.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.6. В случае подтверждения факта неточности персональных данных Администрация на основании сведений, представленных субъектом персональных данных или его представителем либо уполномоченным органом по защите прав субъектов персональных данных, или иных необходимых документов обязан уточнить персональные данные либо обеспечить их уточнение (если обработка персональных данных осуществляется другим лицом, действующим по поручению Администрации) в течение семи рабочих дней со дня представления таких сведений и снять блокирование персональных данных.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.7. В случае выявления неправомерной обработки персональных данных, осуществляемой Администрацией или лицом, действующим по поручению Администрации, Администрация в срок, не превышающий трех рабочих дней с даты этого выявления, обязана прекратить неправомерную обработку персональных данных или обеспечить прекращение неправомерной обработки персональных данных лицом, действующим по поручению Администрацией. В случае, если обеспечить правомерность обработки персональных данных невозможно, Администрация в срок, не превышающий десяти рабочих дней с даты выявления неправомерной обработки персональных данных, обязана уничтожить такие персональные данные или обеспечить их уничтожение. Об устранении допущенных нарушений или об уничтожении персональных данных Администрация обязана уведомить субъекта персональных данных или его представителя, а в случае, если обращение субъекта персональных данных или его представителя либо запрос уполномоченного органа по защите прав субъектов персональных данных были направлены уполномоченным органом по защите прав субъектов персональных данных, также указанный орган.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.8. В случае отзыва субъектом персональных данных согласия на обработку его персональных данных Администрация обязана прекратить их обработку или обеспечить прекращение такой обработки (если обработка персональных данных осуществляется другим лицом, действующим по поручению Администрации) и в случае, если сохранение персональных данных более не требуется для целей обработки персональных данных, уничтожить персональные данные или обеспечить их уничтожение (если обработка персональных данных осуществляется другим лицом, действующим по поручению Администрации) в срок, не превышающий тридцати дней с даты поступления указанного отзыва.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.9. В случае отсутствия возможности уничтожения персональных данных в течение срока, указанного в пункте 3.8 настоящей Политики, Администрация осуществляет блокирование таких персональных данных или обеспечивает их блокирование (если обработка персональных данных осуществляется другим лицом, действующим по поручению Администрации) и обеспечивает уничтожение персональных данных в срок не более чем шесть месяцев, если иной срок не установлен федеральными законами.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					4. ОБЕСПЕЧЕНИЕ БЕЗОПАСНОСТИ ПЕРСОНАЛЬНЫХ ДАННЫХ
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					4.1. Администрация при обработке персональных данных обязана принимать необходимые правовые, организационные и технические меры или обеспечивать их принятие для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.2. Если предоставление персональных данных является обязательным в соответствии с законом, Администрация обязана разъяснить субъекту персональных данных юридические последствия отказа предоставить его персональные данные.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					4.2. Обеспечение безопасности персональных данных достигается:
					<ul>
						<li>
							определением угроз безопасности персональных данных при их обработке в информационных системах персональных данных;
						</li>
						<li>
							применением организационных и технических мер по обеспечению безопасности персональных данных при их обработке в информационных системах персональных данных, необходимых для выполнения требований к защите персональных данных;
						</li>
						<li>
							применением прошедших в установленном порядке процедуру оценки соответствия средств защиты информации;
						</li>
						<li>
							оценкой эффективности принимаемых мер по обеспечению безопасности персональных данных до ввода в эксплуатацию информационной системы персональных данных;
						</li>
						<li>
							учетом машинных носителей персональных данных;
						</li>
						<li>
							обнаружением фактов несанкционированного доступа к персональным данным и принятием мер;
						</li>
						<li>
							восстановлением персональных данных, модифицированных или уничтоженных вследствие несанкционированного доступа к ним;
						</li>
						<li>
							установлением правил доступа к персональным данным, обрабатываемым в информационной системе персональных данных, а также обеспечением регистрации и учета всех действий, совершаемых с персональными данными в информационной системе персональных данных;
						</li>
						<li>
							контролем за принимаемыми мерами по обеспечению безопасности персональных данных и уровня защищенности информационных систем персональных данных.
						</li>
					</ul>
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					5. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					5.1. Контроль соблюдения настоящей Политики осуществляется соответствующим должностными лицами Администрации.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					5.2. Администрация вправе вносить изменений в настоящую Политику по мере необходимости или в силу изменения действующего законодательства. Все изменения подлежат немедленному опубликованию на сайте.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					5.3. На сайте могут быть размещены ссылки на иные Интернет-ресурсы, не контролируемые Администрацией. Переход на указанные Интернет-ресурсы осуществляется исключительно волей субъекта персональных данных. Администрация не несет ответственности за конфиденциальность либо безопасность указанных Интернет-ресурсов.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					5.4. Получение услуг на сайте осуществляется после ознакомления субъекта персональных данных с настоящей Политикой.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					5.5. Продолжая пользоваться сайтом и его услугами, субъект персональных данных подтверждает принятие настоящей Политики в полном объеме
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					5.6. Вопросы в отношении настоящей Политики могут быть заданы по каналам связи, указанным на сайте.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>
		</Wrapper>
	);
};